import { render, staticRenderFns } from "./LibraryMediaDeleteModal.vue?vue&type=template&id=07723908&scoped=true&"
import script from "./LibraryMediaDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./LibraryMediaDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07723908",
  null
  
)

export default component.exports